function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicensesUtilization({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.41,11.28a.83.83,0,0,0,0,1.66h.8a.83.83,0,0,0,0-1.66Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,8.17a.79.79,0,1,1,0-1.58H6.16a.79.79,0,1,1,0,1.58Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,7.38a.81.81,0,0,0-.83-.79H4.5a.79.79,0,1,0,0,1.58H6.16A.81.81,0,0,0,7,7.38Z",
    style: {
      fill: "#3b7ff5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12,15.3v.2a.79.79,0,1,1-1.58,0V9.76h0A2.44,2.44,0,0,1,2,7.38,2.45,2.45,0,0,1,4.5,5H6.16a2.45,2.45,0,0,1,2.5,2.38,2.44,2.44,0,0,1-2.5,2.38h0v3.88H8.21a.75.75,0,0,1,.59.29l2.79-2.21a.48.48,0,0,1,0-.61l.06-.07,7.82-6.15a.61.61,0,0,1,0-.14,1,1,0,0,1,1-1,1,1,0,0,1,.74.33l2.53-2A2,2,0,0,0,22,1H2A2,2,0,0,0,0,3V18a2,2,0,0,0,1.3,1.87L7.07,15.3ZM9,12.11a.81.81,0,0,1-.79.83h-.8a.83.83,0,0,1,0-1.66h.8A.81.81,0,0,1,9,12.11Z",
    style: {
      fill: "#3b7ff5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,20a2,2,0,0,0,2-2V3a2.05,2.05,0,0,0-.23-.92l-2.53,2a1,1,0,0,1-.74,1.67,1.11,1.11,0,0,1-.37-.07l-7.82,6.15a.5.5,0,0,1-.7-.08l0,0L8.8,13.93a.85.85,0,0,1,.2.54.81.81,0,0,1-.79.83H7.07L1.3,19.87A2,2,0,0,0,2,20ZM19,8.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v7a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5Zm-4,3a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5Zm-4,3a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5Z",
    style: {
      fill: "#4d94ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,21H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#4d94ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensesUtilization);
export default __webpack_public_path__ + "static/media/licenses-utilization.03db3cd6e7931da204aff546e5943c3f.svg";
export { ForwardRef as ReactComponent };